<template>
  <transition name="fade">
    <div v-if="visible" class="login-dialog-layer" @click.self="handleOverlayClick">
      <div class="login-dialog-container">
        <div class="close-btn" @click="handleClose">
          <img src="@/assets/image/close-btn.png" alt="关闭" />
        </div>
        <div class="dialog-content">
          <div class="left-area">
            <div class="logo-container">
              <img src="@/assets/image/login-logo.png" alt="logo" />
            </div>
          </div>
          <div class="right-area">
            <!-- 右上角扫码切换角标：登录/注册时显示 -->
            <img
              v-if="currentTab === 'login' || currentTab === 'register'"
              class="qr-corner"
              :src="qrCornerIcon"
              alt="二维码登录"
              @click="switchTab('qrcode')"
            />

            <!-- 扫码登录 -->
            <div v-if="currentTab === 'qrcode'" class="qrcode-content">
              <div class="welcome-row">
                <div class="decoration-left">
                  <span class="line"></span>
                  <span class="dot"></span>
                </div>
                <span class="welcome-text">Welcome</span>
                <div class="decoration-right">
                  <span class="dot"></span>
                  <span class="line"></span>
                </div>
              </div>
              <div class="qrcode-title">微信二维码登录</div>
              <div class="qrcode-box">
                <img v-show="qrcodePath" :src="qrcodePath" alt="二维码登录" />
                <span v-show="!qrcodePath" class="qrcode-loading">加载中...</span>
              </div>
              <div class="qrcode-tip">请使用微信扫码登录</div>
              <div class="other-login-link accent" @click="switchTab('login')">其他方式登录</div>
            </div>

            <!-- 登录 -->
            <template v-else-if="currentTab === 'login'">
              <div class="tab-container">
                <span class="tab-item active">登录</span>
                <span class="tab-item" @click="switchTab('register')">注册</span>
              </div>
              <div class="form-content login-content">
                <div class="input-wrapper">
                  <div class="input-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="6" y="3" width="12" height="18" rx="2"></rect>
                        <line x1="12" y1="17" x2="12" y2="17"></line>
                      </g>
                    </svg>
                  </div>
                  <input type="text" placeholder="手机号" maxlength="11" v-model="loginForm.mobile" />
                </div>
                <div class="input-wrapper">
                  <div class="input-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                      <g fill="none">
                        <path d="M7.836 1.505L8 1.5a2.5 2.5 0 0 1 2.495 2.336L10.5 4v1h1A1.5 1.5 0 0 1 13 6.5v6a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 3 12.5v-6A1.5 1.5 0 0 1 4.5 5h1V4a2.5 2.5 0 0 1 2.336-2.495zM11.5 6h-7a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5zM8 8.5a1 1 0 1 1 0 2a1 1 0 0 1 0-2zm.144-5.993L8 2.5a1.5 1.5 0 0 0-1.493 1.356L6.5 4v1h3V4a1.5 1.5 0 0 0-1.356-1.493z" fill="currentColor"></path>
                      </g>
                    </svg>
                  </div>
                  <input
                    :type="showLoginPassword ? 'text' : 'password'"
                    placeholder="密码"
                    maxlength="20"
                    v-model="loginForm.password"
                  />
                  <div class="eye-icon" @click="showLoginPassword = !showLoginPassword">
                    <svg v-if="showLoginPassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path fill="currentColor" d="M12 5c-7 0-10 7-10 7s3 7 10 7s10-7 10-7s-3-7-10-7zm0 12a5 5 0 1 1 0-10a5 5 0 0 1 0 10zm0-8a3 3 0 1 0 0 6a3 3 0 0 0 0-6z"/>
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path fill="currentColor" d="M2 5.27L3.28 4L20 20.72L18.73 22l-3.04-3.04A10.47 10.47 0 0 1 12 19c-7 0-10-7-10-7a17.5 17.5 0 0 1 4.66-5.35L2 5.27zM12 9a3 3 0 0 1 3 3c0 .36-.07.7-.18 1.02l-3.84-3.84C11.3 9.07 11.64 9 12 9zm0-4c7 0 10 7 10 7a17.5 17.5 0 0 1-4.12 5.05l-1.43-1.43A15.3 15.3 0 0 0 20.13 12S17.58 7.5 12 7.5c-.86 0-1.66.12-2.4.32L7.97 6.2A11.3 11.3 0 0 1 12 5z"/>
                    </svg>
                  </div>
                </div>
                <div class="forgot-password-wrapper">
                  <span class="forgot-password-btn" @click="switchTab('reset')">忘记密码</span>
                </div>
                <button class="login-btn" @click="handleLogin">立即体验</button>
                <div class="other-login-link" @click="switchTab('qrcode')">二维码登录</div>
              </div>
            </template>

            <!-- 注册 -->
            <template v-else-if="currentTab === 'register'">
              <div class="tab-container">
                <span class="tab-item" @click="switchTab('login')">登录</span>
                <span class="tab-item active">注册</span>
              </div>
              <div class="form-content register-content">
                <div class="input-wrapper">
                  <div class="input-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="6" y="3" width="12" height="18" rx="2"></rect>
                        <line x1="12" y1="17" x2="12" y2="17"></line>
                      </g>
                    </svg>
                  </div>
                  <input type="text" placeholder="手机号" maxlength="11" v-model="registerForm.mobile" />
                </div>
                <div class="input-wrapper">
                  <div class="input-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                      <g fill="none">
                        <path d="M7.836 1.505L8 1.5a2.5 2.5 0 0 1 2.495 2.336L10.5 4v1h1A1.5 1.5 0 0 1 13 6.5v6a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 3 12.5v-6A1.5 1.5 0 0 1 4.5 5h1V4a2.5 2.5 0 0 1 2.336-2.495zM11.5 6h-7a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5zM8 8.5a1 1 0 1 1 0 2a1 1 0 0 1 0-2zm.144-5.993L8 2.5a1.5 1.5 0 0 0-1.493 1.356L6.5 4v1h3V4a1.5 1.5 0 0 0-1.356-1.493z" fill="currentColor"></path>
                      </g>
                    </svg>
                  </div>
                  <input
                    :type="showRegisterPassword ? 'text' : 'password'"
                    placeholder="密码"
                    maxlength="20"
                    v-model="registerForm.password"
                  />
                  <div class="eye-icon" @click="showRegisterPassword = !showRegisterPassword">
                    <svg v-if="showRegisterPassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path fill="currentColor" d="M12 5c-7 0-10 7-10 7s3 7 10 7s10-7 10-7s-3-7-10-7zm0 12a5 5 0 1 1 0-10a5 5 0 0 1 0 10zm0-8a3 3 0 1 0 0 6a3 3 0 0 0 0-6z"/>
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path fill="currentColor" d="M2 5.27L3.28 4L20 20.72L18.73 22l-3.04-3.04A10.47 10.47 0 0 1 12 19c-7 0-10-7-10-7a17.5 17.5 0 0 1 4.66-5.35L2 5.27zM12 9a3 3 0 0 1 3 3c0 .36-.07.7-.18 1.02l-3.84-3.84C11.3 9.07 11.64 9 12 9zm0-4c7 0 10 7 10 7a17.5 17.5 0 0 1-4.12 5.05l-1.43-1.43A15.3 15.3 0 0 0 20.13 12S17.58 7.5 12 7.5c-.86 0-1.66.12-2.4.32L7.97 6.2A11.3 11.3 0 0 1 12 5z"/>
                    </svg>
                  </div>
                </div>
                <div class="input-wrapper">
                  <div class="input-icon image-icon">
                    <img :src="userIcon" alt="邀请码" />
                  </div>
                  <input type="text" placeholder="邀请码" maxlength="20" v-model="registerForm.inviteCode" />
                </div>
                <div class="captcha-wrapper">
                  <div class="input-wrapper captcha-input">
                    <div class="input-icon image-icon">
                      <img :src="keyIcon" alt="图形验证码" />
                    </div>
                    <input type="text" placeholder="图形验证码" maxlength="10" v-model="captchaCode" />
                  </div>
                  <img
                    v-if="captchaImage"
                    class="captcha-img"
                    :src="captchaImage"
                    alt="图形验证码"
                    @click="fetchCaptcha"
                  />
                  <div v-else class="captcha-img captcha-placeholder" @click="fetchCaptcha">
                    点击刷新
                  </div>
                </div>
                <div class="verification-wrapper">
                  <div class="input-wrapper verification-input-wrapper">
                    <div class="input-icon image-icon">
                      <img :src="keyIcon" alt="短信验证码" />
                    </div>
                    <input type="text" placeholder="短信验证码" maxlength="20" v-model="registerForm.verificationCode" />
                  </div>
                  <button
                    class="get-code-btn"
                    :class="{ disabled: isCounting }"
                    :disabled="isCounting"
                    @click="handleGetCode('1')"
                  >
                    {{ isCounting ? `${countdown}秒后重新获取` : '获取验证码' }}
                  </button>
                </div>
                <button class="login-btn" @click="handleRegister">立即注册</button>
                <div class="other-login-link" @click="switchTab('qrcode')">二维码登录</div>
              </div>
            </template>

            <!-- 重置密码 -->
            <template v-else-if="currentTab === 'reset'">
              <div class="tab-container single">重置密码</div>
              <div class="form-content reset-content">
                <div class="input-wrapper">
                  <div class="input-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="6" y="3" width="12" height="18" rx="2"></rect>
                        <line x1="12" y1="17" x2="12" y2="17"></line>
                      </g>
                    </svg>
                  </div>
                  <input type="text" placeholder="手机号" maxlength="11" v-model="resetForm.mobile" />
                </div>
                <div class="captcha-wrapper">
                  <div class="input-wrapper captcha-input">
                    <div class="input-icon image-icon">
                      <img :src="keyIcon" alt="图形验证码" />
                    </div>
                    <input type="text" placeholder="图形验证码" maxlength="10" v-model="captchaCode" />
                  </div>
                  <img
                    v-if="captchaImage"
                    class="captcha-img"
                    :src="captchaImage"
                    alt="图形验证码"
                    @click="fetchCaptcha"
                  />
                  <div v-else class="captcha-img captcha-placeholder" @click="fetchCaptcha">
                    点击刷新
                  </div>
                </div>
                <div class="verification-wrapper">
                  <div class="input-wrapper verification-input-wrapper">
                    <div class="input-icon image-icon">
                      <img :src="keyIcon" alt="短信验证码" />
                    </div>
                    <input type="text" placeholder="短信验证码" maxlength="20" v-model="resetForm.verificationCode" />
                  </div>
                  <button
                    class="get-code-btn"
                    :class="{ disabled: isCounting }"
                    :disabled="isCounting"
                    @click="handleGetCode('2')"
                  >
                    {{ isCounting ? `${countdown}秒后重新获取` : '获取验证码' }}
                  </button>
                </div>
                <div class="input-wrapper">
                  <div class="input-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                      <g fill="none">
                        <path d="M7.836 1.505L8 1.5a2.5 2.5 0 0 1 2.495 2.336L10.5 4v1h1A1.5 1.5 0 0 1 13 6.5v6a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 3 12.5v-6A1.5 1.5 0 0 1 4.5 5h1V4a2.5 2.5 0 0 1 2.336-2.495zM11.5 6h-7a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5zM8 8.5a1 1 0 1 1 0 2a1 1 0 0 1 0-2zm.144-5.993L8 2.5a1.5 1.5 0 0 0-1.493 1.356L6.5 4v1h3V4a1.5 1.5 0 0 0-1.356-1.493z" fill="currentColor"></path>
                      </g>
                    </svg>
                  </div>
                  <input
                    :type="showResetPassword ? 'text' : 'password'"
                    placeholder="新密码"
                    maxlength="20"
                    v-model="resetForm.newPassword"
                  />
                </div>
                <div class="forgot-password-wrapper">
                  <span class="forgot-password-btn" @click="switchTab('login')">已有账号?去登录</span>
                </div>
                <button class="login-btn" @click="handleResetPassword">确认修改</button>
                <div class="other-login-link" @click="switchTab('qrcode')">二维码登录</div>
              </div>
            </template>

            <div class="agreement-wrapper">
              <span class="agreement-text">若登录则表示已阅读并同意本网站的</span>
              <span class="agreement-link" @click="handleAgreement">《用户协议》</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {
  inputLogin,
  register,
  resetPassword,
  getGraphicCaptcha,
  sendSmsCodeWithCaptcha,
  getQrcode,
  getLoginStatus,
  scanLogin,
} from '@/api/index';
import { timeoutTask } from '@/utils/index';

let btnLock = false;
let loopLock = false;

const ASSET = {
  keyIcon: 'https://static.hudongmiao.com/miao/common/keyIcon_17839942078489d1958.webp',
  qrCorner: 'https://static.hudongmiao.com/miao/common/qrcode-grey_1783994207848e850ce.webp',
  userIcon: 'https://static.hudongmiao.com/miao/common/user-icon_1783994207849d6ed7d.webp',
};

export default {
  name: 'LoginDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentTab: 'login', // login | register | reset | qrcode
      keyIcon: ASSET.keyIcon,
      qrCornerIcon: ASSET.qrCorner,
      userIcon: ASSET.userIcon,
      loginForm: {
        mobile: '',
        password: '',
      },
      registerForm: {
        mobile: '',
        password: '',
        inviteCode: '',
        verificationCode: '',
      },
      resetForm: {
        mobile: '',
        verificationCode: '',
        newPassword: '',
      },
      showLoginPassword: false,
      showRegisterPassword: false,
      showResetPassword: false,
      captchaId: '',
      captchaImage: '',
      captchaCode: '',
      smsExt: '',
      smsCodeId: '',
      countdown: 60,
      isCounting: false,
      countdownTimer: null,
      qrcodePath: '',
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.resetDialogState();
        this.currentTab = 'login';
      } else {
        this.cleanup();
      }
    },
  },
  beforeDestroy() {
    this.cleanup();
  },
  methods: {
    cleanup() {
      loopLock = true;
      btnLock = false;
      this.stopCountdown();
      this.qrcodePath = '';
    },
    resetDialogState() {
      loopLock = true;
      btnLock = false;
      this.stopCountdown();
      this.showLoginPassword = false;
      this.showRegisterPassword = false;
      this.showResetPassword = false;
      this.captchaId = '';
      this.captchaImage = '';
      this.captchaCode = '';
      this.smsExt = '';
      this.smsCodeId = '';
      this.qrcodePath = '';
    },
    handleOverlayClick() {
      // overlay 点击不关闭
    },
    handleClose() {
      this.cleanup();
      this.$emit('close');
    },
    switchTab(tab) {
      if (tab === this.currentTab) {
        return;
      }
      // 离开扫码页时停止轮询
      if (this.currentTab === 'qrcode' && tab !== 'qrcode') {
        loopLock = true;
      }
      this.currentTab = tab;
      this.captchaCode = '';
      if (tab === 'register') {
        if (this.$store && this.$store.state.inviteCode) {
          this.registerForm.inviteCode = this.$store.state.inviteCode;
        }
        this.fetchCaptcha();
      } else if (tab === 'reset') {
        this.fetchCaptcha();
      } else if (tab === 'qrcode') {
        this.requestQrcode();
      }
    },
    toastError(msg) {
      if (this.$message) {
        this.$message.error(msg);
      }
    },
    toastSuccess(msg) {
      if (this.$message) {
        this.$message({ message: msg, type: 'success' });
      }
    },
    validatePhone(phone) {
      if (!phone) {
        this.toastError('请输入手机号!');
        return false;
      }
      if (phone.length !== 11) {
        this.toastError('手机号格式错误!');
        return false;
      }
      return true;
    },
    afterLoginSuccess(res, password) {
      if (this.$store) {
        this.$store.commit('updateUserInfo', {
          userName: res.emcee_name,
          headImg: res.avator,
          phone: res.phonenumber,
          token: res.token,
          password: password || '',
        });
      }
      this.$emit('close');
      const redirectUrl = `${window.location.origin}/bar-customer/index.html#/app/home`;
      window.location.href = redirectUrl;
    },
    handleLogin() {
      if (!this.validatePhone(this.loginForm.mobile)) {
        return;
      }
      if (!this.loginForm.password) {
        this.toastError('请输入密码!');
        return;
      }
      if (btnLock) {
        return;
      }
      btnLock = true;
      inputLogin({
        phone: this.loginForm.mobile,
        password: this.loginForm.password,
      })
        .then((res) => {
          btnLock = false;
          if (res.token) {
            this.afterLoginSuccess(res, this.loginForm.password);
          } else if (res.code === '500') {
            this.toastError(res.errMsg || res.msg || '登录失败');
          } else {
            this.toastError('登录失败，请稍后重试');
          }
        })
        .catch(() => {
          btnLock = false;
          this.toastError('登录失败，请稍后重试');
        });
    },
    handleRegister() {
      if (!this.validatePhone(this.registerForm.mobile)) {
        return;
      }
      if (!this.registerForm.password) {
        this.toastError('请输入密码!');
        return;
      }
      if (!this.registerForm.inviteCode) {
        this.toastError('请输入邀请码!');
        return;
      }
      if (!this.registerForm.verificationCode) {
        this.toastError('请输入短信验证码!');
        return;
      }
      if (!this.smsCodeId || !this.smsExt) {
        this.toastError('请先获取短信验证码!');
        return;
      }
      if (btnLock) {
        return;
      }
      btnLock = true;
      register({
        phone: this.registerForm.mobile,
        password: this.registerForm.password,
        inviteCode: this.registerForm.inviteCode,
        valiCode: this.registerForm.verificationCode,
        ext: this.smsExt,
        codeId: this.smsCodeId,
      })
        .then((res) => {
          btnLock = false;
          if (String(res.code) === '200') {
            this.toastSuccess(res.msg || '注册成功');
            // zhuceBar 仅返回成功状态，引导去登录
            this.loginForm.mobile = this.registerForm.mobile;
            this.loginForm.password = this.registerForm.password;
            this.switchTab('login');
          } else {
            this.toastError(res.msg || res.errMsg || '注册失败');
          }
        })
        .catch(() => {
          btnLock = false;
          this.toastError('注册失败，请稍后重试');
        });
    },
    handleResetPassword() {
      if (!this.validatePhone(this.resetForm.mobile)) {
        return;
      }
      if (!this.resetForm.verificationCode) {
        this.toastError('请输入短信验证码!');
        return;
      }
      if (!this.resetForm.newPassword) {
        this.toastError('请输入新密码!');
        return;
      }
      if (!this.smsCodeId || !this.smsExt) {
        this.toastError('请先获取短信验证码!');
        return;
      }
      if (btnLock) {
        return;
      }
      btnLock = true;
      resetPassword({
        phone: this.resetForm.mobile,
        password: this.resetForm.newPassword,
        codeId: this.smsCodeId,
        ext: this.smsExt,
        valiCode: this.resetForm.verificationCode,
      })
        .then((res) => {
          btnLock = false;
          if (String(res.code) === '200') {
            this.toastSuccess(res.msg || '密码修改成功');
            this.loginForm.mobile = this.resetForm.mobile;
            this.loginForm.password = this.resetForm.newPassword;
            this.switchTab('login');
          } else {
            this.toastError(res.msg || res.errMsg || '修改失败');
          }
        })
        .catch(() => {
          btnLock = false;
          this.toastError('修改失败，请稍后重试');
        });
    },
    handleGetCode(source) {
      if (this.isCounting) {
        return;
      }
      const phone = source === '1' ? this.registerForm.mobile : this.resetForm.mobile;
      if (!this.validatePhone(phone)) {
        return;
      }
      if (!this.captchaCode) {
        this.toastError('请输入图形验证码!');
        return;
      }
      if (!this.captchaId) {
        this.toastError('图形验证码已失效，请刷新后重试');
        this.fetchCaptcha();
        return;
      }
      if (btnLock) {
        return;
      }
      btnLock = true;
      sendSmsCodeWithCaptcha({
        phone,
        source,
        captchaId: this.captchaId,
        captchaCode: this.captchaCode,
      })
        .then((res) => {
          btnLock = false;
          if (String(res.code) === '200') {
            this.smsExt = res.data.ext || '';
            this.smsCodeId = res.data.codeId || '';
            this.toastSuccess(res.msg || '验证码已发送，请查收');
            this.startCountdown();
          } else {
            this.toastError(res.msg || '获取验证码失败');
            this.fetchCaptcha();
          }
        })
        .catch(() => {
          btnLock = false;
          this.toastError('获取验证码失败，请稍后重试');
          this.fetchCaptcha();
        });
    },
    fetchCaptcha() {
      this.captchaCode = '';
      getGraphicCaptcha()
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.captchaId = res.data.captchaId;
            this.captchaImage = res.data.imageBase64;
          } else {
            this.toastError(res.msg || '获取图形验证码失败');
          }
        })
        .catch(() => {
          this.toastError('获取图形验证码失败');
        });
    },
    startCountdown() {
      this.stopCountdown();
      this.isCounting = true;
      this.countdown = 60;
      this.countdownTimer = setInterval(() => {
        this.countdown -= 1;
        if (this.countdown <= 0) {
          this.stopCountdown();
        }
      }, 1000);
    },
    stopCountdown() {
      this.isCounting = false;
      this.countdown = 60;
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },
    requestQrcode() {
      if (btnLock) {
        return;
      }
      btnLock = true;
      this.qrcodePath = '';
      getQrcode()
        .then((res) => {
          btnLock = false;
          this.qrcodePath = res.WXQRCodeUrl;
          loopLock = false;
          this.loopRequestLoginStatus(res.loginKey);
        })
        .catch(() => {
          btnLock = false;
          this.toastError('获取二维码失败，请稍后重试');
        });
    },
    loopRequestLoginStatus(loginKey) {
      if (loopLock || this.currentTab !== 'qrcode' || !this.visible) {
        return;
      }
      getLoginStatus(loginKey)
        .then((res) => {
          if (loopLock || this.currentTab !== 'qrcode' || !this.visible) {
            return;
          }
          const data = res.data || {};
          if (data.val === '0') {
            timeoutTask(() => {
              this.loopRequestLoginStatus(data.loginKey || loginKey);
            }, 2000);
          } else if (data.val === '1') {
            loopLock = true;
            this.requestScanLogin(data.token);
          } else if (data.val === '2') {
            loopLock = true;
            this.toastError('您还未拥有账号，请注册!');
            this.switchTab('register');
          } else {
            loopLock = true;
            this.toastError('登录失败!');
          }
        })
        .catch(() => {
          if (!loopLock && this.currentTab === 'qrcode' && this.visible) {
            timeoutTask(() => {
              this.loopRequestLoginStatus(loginKey);
            }, 2000);
          }
        });
    },
    requestScanLogin(token) {
      scanLogin(token)
        .then((res) => {
          if (res.token) {
            this.afterLoginSuccess(res, '');
          } else if (res.code === '500') {
            this.toastError(res.errMsg || res.msg || '登录失败');
          } else {
            this.toastError('登录失败，请稍后重试');
          }
        })
        .catch(() => {
          this.toastError('登录失败，请稍后重试');
        });
    },
    handleAgreement() {
      // 用户协议：如有独立页面可在此跳转
    },
  },
};
</script>

<style lang="less" scoped>
.login-dialog-layer {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000 !important;
}

.login-dialog-container {
  width: 996px;
  height: 584px;
  background-color: #fff;
  position: relative;
  display: flex;
  flex-direction: row;
}

.dialog-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
}

.left-area {
  width: 409px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(180deg, #E29DFF 0%, #A287FF 100%);
}

.logo-container {
  width: 219px;
  height: 284px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.right-area {
  width: 587px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 48px 90px 20px 90px;
  position: relative;
  box-sizing: border-box;
}

.qr-corner {
  width: 93px;
  height: 78px;
  position: absolute;
  top: 0;
  right: 6px;
  cursor: pointer;
  z-index: 2;

  &:hover {
    opacity: 0.85;
  }
}

.tab-container {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 34px;

  &.single {
    font-size: 28px;
    color: #000;
    font-weight: bold;
  }

  .tab-item {
    font-size: 28px;
    font-weight: bold;
    color: #969696;
    cursor: pointer;
    user-select: none;

    &.active {
      color: #000;
      font-weight: 500;
      cursor: default;
    }

    &:hover:not(.active) {
      opacity: 0.8;
    }
  }
}

.form-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.login-content {
  gap: 20px;
  margin-top: 40px;

  .login-btn {
    margin-top: 20px;
  }
}

.register-content {
  gap: 12px;
  margin-top: 20px;

  .login-btn {
    margin-top: 8px;
  }
}

.reset-content {
  gap: 14px;
  margin-top: 28px;

  .login-btn {
    margin-top: 8px;
  }
}

.qrcode-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;

  .welcome-row {
    margin-top: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .decoration-left,
    .decoration-right {
      display: flex;
      align-items: center;

      .dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #8964FF;
      }

      .line {
        width: 66px;
        height: 2px;
        background: #8964FF;
      }
    }

    .decoration-left {
      margin-right: 30px;

      .dot {
        margin-left: 10px;
      }
    }

    .decoration-right {
      margin-left: 30px;

      .dot {
        margin-right: 10px;
      }
    }

    .welcome-text {
      font-size: 28px;
      font-weight: bold;
      color: #8964FF;
    }
  }

  .qrcode-title {
    font-weight: bold;
    color: #000;
    font-size: 28px;
    margin-top: 36px;
  }

  .qrcode-box {
    width: 236px;
    height: 236px;
    border: 1px solid #8964FF;
    margin-top: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;

    img {
      width: 212px;
      height: 212px;
      object-fit: contain;
    }

    .qrcode-loading {
      font-size: 18px;
      color: #8964FF;
    }
  }

  .qrcode-tip {
    color: #83838b;
    font-weight: 400;
    font-size: 22px;
    margin-top: 10px;
  }

  .other-login-link {
    margin-top: 6px;
  }
}

.input-wrapper {
  width: 100%;
  height: 51px;
  display: flex;
  align-items: center;
  border: 1px solid #E0E0E0;
  border-radius: 4px;
  padding: 0 16px;
  box-sizing: border-box;
  transition: border-color 0.3s;

  &:focus-within {
    border: 1px solid #8964FF;
  }

  .input-icon {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    flex-shrink: 0;
    color: #999;

    svg {
      width: 100%;
      height: 100%;
    }

    &.image-icon img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .eye-icon {
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
    flex-shrink: 0;
    color: #999;
    cursor: pointer;

    svg {
      width: 100%;
      height: 100%;
    }

    &:hover {
      opacity: 0.8;
    }
  }

  input {
    flex: 1;
    height: 100%;
    border: none;
    outline: none;
    font-size: 18px;
    line-height: 51px;
    color: #333;
    background: transparent;
    padding: 0;
    margin: 0;

    &::placeholder {
      color: #999;
      font-size: 18px;
    }
  }
}

.forgot-password-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: -4px;
}

.forgot-password-btn {
  font-weight: 400;
  font-size: 18px;
  color: #8964FF;
  cursor: pointer;
  user-select: none;

  &:hover {
    opacity: 0.8;
  }
}

.login-btn {
  width: 403px;
  height: 58px;
  background: linear-gradient(90deg, #8964FF 0%, #CD5EFB 100%);
  border-radius: 29px;
  font-weight: 500;
  font-size: 22px;
  color: #FFFFFF;
  border: none;
  cursor: pointer;
  margin-top: 10px;
  align-self: center;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    opacity: 0.8;
  }
}

.other-login-link {
  font-weight: 400;
  color: #83838b;
  font-size: 20px;
  width: 100%;
  text-align: center;
  margin-top: 12px;
  cursor: pointer;
  user-select: none;

  &:hover {
    color: #8964FF;
  }

  &.accent {
    color: #8964FF;

    &:hover {
      opacity: 0.85;
    }
  }
}

.agreement-wrapper {
  width: 100%;
  margin-top: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-top: 12px;
}

.agreement-text {
  font-weight: 400;
  font-size: 16px;
  color: #919191;
}

.agreement-link {
  font-weight: 400;
  font-size: 16px;
  color: #8964FF;
  cursor: pointer;
  user-select: none;

  &:hover {
    opacity: 0.8;
  }
}

.captcha-wrapper,
.verification-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
}

.captcha-input,
.verification-input-wrapper {
  flex: 1;
}

.captcha-img {
  height: 51px;
  width: 130px;
  cursor: pointer;
  border-radius: 4px;
  flex-shrink: 0;
  object-fit: contain;
  border: 1px solid #E0E0E0;
  box-sizing: border-box;

  &:hover {
    opacity: 0.85;
  }
}

.captcha-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  font-size: 14px;
  color: #999;
}

.get-code-btn {
  height: 51px;
  padding: 0 8px;
  background: transparent;
  border: none;
  font-weight: 400;
  font-size: 18px;
  color: #8964FF;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: color 0.3s, opacity 0.3s;

  &:hover:not(.disabled) {
    opacity: 0.8;
  }

  &.disabled {
    color: #CCCCCC;
    cursor: not-allowed;
    opacity: 1;
  }
}

.close-btn {
  position: absolute;
  top: -41px;
  right: -41px;
  width: 41px;
  height: 41px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active .login-dialog-container,
.fade-leave-active .login-dialog-container {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.fade-enter .login-dialog-container,
.fade-leave-to .login-dialog-container {
  opacity: 0;
  transform: scale(0.9);
}

.fade-enter-to {
  opacity: 1;
}

.fade-enter-to .login-dialog-container {
  opacity: 1;
  transform: scale(1);
}
</style>
